<template>
  <div v-if="isShow" v-show="false">
    <div ref="label" class="bad-mark-label-list">
      <article v-for="(labelData, labelIndex) in labelDataList" :key="labelIndex" class="bad-mark-label-page">
        <main class="bad-mark-label">
          <header class="label-header">
            <div class="print-date">打印日期：{{ labelData.print_date }}</div>
            <div class="customer-attribute">{{ labelData.customer_attribute }}</div>
            <div class="customer-name">客户名：{{ labelData.user_name }}</div>
          </header>

          <section class="bad-section">
            <div class="bad-count">不良数&nbsp;&nbsp;<strong>{{ labelData.bad_num }}</strong></div>
            <div class="bad-code" :style="{ fontSize: getBadCodeFontSize(labelData.bad_mark_code) }">
              <span>不良品编码：</span>
              <strong>{{ labelData.bad_mark_code }}</strong>
            </div>
            <img class="bad-code-barcode" :src="badCodeBarcodeUrls[labelIndex]" alt="">
            <div class="bad-code-text">{{ labelData.bad_code }}</div>
          </section>

          <section class="express-section">
            <div class="express-title">物流号： <strong>{{ labelData.express_no }}</strong></div>
          </section>

          <footer class="staff-section">
            <div class="checker">检查员：<strong>{{ labelData.checker_name }}</strong></div>
            <div class="staff-list">
              <div>检品：<strong>{{ labelData.inspector_name }}</strong></div>
              <div>采购：<strong>{{ labelData.purchaser_name }}</strong></div>
              <div>业务：<strong>{{ labelData.salesman_name }}</strong></div>
            </div>
          </footer>
        </main>
      </article>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import { getCurrentTime } from '@/utlis/date'

export default {
  name: 'BadMarkLabel',
  data() {
    return {
      isShow: false,
      labelDataList: [],
      badCodeBarcodeUrls: []
    }
  },
  methods: {
    getBadCodeFontSize(code) {
      const codeLength = String(code || '').length
      if (codeLength > 28) return '40px'
      if (codeLength > 22) return '46px'
      return '52px'
    },
    print(data) {
      this.printList([data])
    },
    printList(dataList) {
      this.labelDataList = dataList.map(data => ({
        ...data,
        // 不良品条码固定使用 BL + 不良记录 ID，供扫码直接定位记录。
        bad_code: `BL-${data.bad_id}`,
        print_date: getCurrentTime()
      }))
      this.isShow = true
      this.$nextTick(() => {
        this.createBarcodes()
        this.$nextTick(() => {
          this.$print(this.$refs.label)
          this.isShow = false
        })
      })
    },
    createBarcodes() {
      this.badCodeBarcodeUrls = this.labelDataList.map(data => this.createBarcode(data.bad_code))
    },
    createBarcode(value) {
      if (!value) return ''
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, value, {
        format: 'CODE128',
        displayValue: false,
        height: 200,
        width: 4,
        margin: 0,
        lineColor: '#000000'
      })
      return canvas.toDataURL('image/png')
    }
  }
}
</script>

<style lang="scss" scoped>
$border-width: 3px;
$content-width: 1074px;

.bad-mark-label-page {
  position: relative;
  width: 100%;
  height: 1600px;
}

.bad-mark-label {
  position: relative;
  box-sizing: border-box;
  width: 1080px;
  height: 1600px;
  margin: 0 auto !important;
  border: $border-width solid #000;
  overflow: hidden;
  color: #000;
  background: #fff;
  font-family: "Microsoft YaHei", SimHei, Arial, sans-serif;
}

.label-header {
  position: absolute;
  inset: 0 0 auto 0;
  box-sizing: border-box;
  width: $content-width;
  height: 240px;
  border-bottom: $border-width solid #000;
}

.print-date {
  position: absolute;
  top: 30px;
  left: 35px;
  font-size: 32px;
  line-height: 42px;
}

.customer-attribute {
  position: absolute;
  top: 25px;
  right: 35px;
  font-size: 60px;
  font-weight: 700;
  line-height: 66px;
}

.customer-name {
  position: absolute;
  top: 145px;
  left: 35px;
  max-width: 1000px;
  overflow: hidden;
  font-size: 48px;
  line-height: 60px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bad-section {
  position: absolute;
  top: 240px;
  left: 0;
  box-sizing: border-box;
  width: $content-width;
  height: 780px;
  text-align: center;
}

.bad-count {
  position: absolute;
  top: 70px;
  left: 0;
  width: 100%;
  font-size: 68px;
  line-height: 80px;
  white-space: nowrap;
}

.bad-code {
  position: absolute;
  top: 220px;
  left: 0;
  width: 100%;
  line-height: 64px;
  overflow: hidden;
  white-space: nowrap;
}

.bad-code-barcode {
  position: absolute;
  top: 340px;
  left: 85px;
  display: block;
  width: 904px !important;
  height: 200px !important;
}

.bad-code-text {
  position: absolute;
  top: 570px;
  left: 0;
  width: 100%;
  font-size: 46px;
  font-weight: 700;
  line-height: 58px;
  text-align: center;
  white-space: nowrap;
}

.express-section {
  position: absolute;
  top: 1020px;
  left: 0;
  box-sizing: border-box;
  width: $content-width;
  height: 330px;
  border-top: $border-width solid #000;
  text-align: center;
}

.express-title {
  margin-top: 125px;
  font-size: 46px;
  line-height: 58px;
  white-space: nowrap;
}

.staff-section {
  position: absolute;
  top: 1350px;
  left: 0;
  box-sizing: border-box;
  width: $content-width;
  height: 246px;
  border-top: $border-width solid #000;
  font-size: 38px;
  line-height: 58px;
}

.checker {
  position: absolute;
  left: 35px;
  bottom: 90px;
}

.staff-list {
  position: absolute;
  right: 35px;
  bottom: 28px;
  min-width: 270px;
}

@media print {
  .bad-mark-label-page {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    page-break-after: always;
    page-break-inside: avoid;
    break-after: page;
    break-inside: avoid;
  }

  .bad-mark-label-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }

  .bad-mark-label {
    position: relative;
    flex: 0 0 auto;
    width: 1080px;
    height: 1600px;
    margin: 0 !important;
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
</style>
